import { Box, Divider, Grid } from "@mui/material";
import { MenusProps } from "../"
import { escurecerCor } from "../../../../helpers/manipulacaoCores"
import { colors } from "../../bannerColors"
import TemplateDashboardComOpcoes from "../../Templates/TemplateDashboardComOpcoes";
import SettingsIcon from '@mui/icons-material/Settings';
import TemplateOpcoes from "../../Templates/TemplateOpcoes";
import AddIcon from "@mui/icons-material/Add";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import { usePermission } from "../../../PermissionGuard";

export default function FabricaMenu({ type }: MenusProps) {

  const color = colors[type] || "#1E2E6B"
  const textColor = escurecerCor(color)

  return (
    <Box>
      <Grid container spacing={2}>
        <TemplateDashboardComOpcoes
          {...{ type }}
          color={textColor}
          items={[
            {
              label: "Configurações",
              icon: <SettingsIcon fontSize="inherit" />,
              action: () => {},
              disabled: !usePermission('fabrica.configuracoes')
            }
          ]}
        />

        <Divider orientation="vertical" sx={{ border: '1px solid', borderColor: 'divider', }} flexItem />

        <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
          <TemplateOpcoes
            title="Fabrica"
            color={textColor}
            items={[
              {
                label: "Solicitar insumo",
                icon: <AddIcon fontSize="inherit" />,
                action: () => {},
                disabled: !usePermission('fabrica.solicitar-insumos'),
              },
              {
                label: "Listar todos",
                icon: <ListOutlinedIcon fontSize="inherit" />,
                action: () => {},
                disabled: !usePermission("fabrica.listar-todos"),
              },
            ]}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

